import * as React from 'react';
import { Group, Button, createStyles } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const useStyles = createStyles((theme) => ({
    formInsert: {
        paddingLeft: '1.25rem',
        paddingRight: '1.25rem'
    }
}));

interface ActionButtonsProps {
    activeStep?: number;
    formInsert?: boolean;
    isLoading?: boolean;
    prevStep?: () => void;
    nextStep?: () => void;
    setError: (error: Record<string, string | null> | string | null) => void;
    validator?: () => Record<string, string | null> | string | null;
    setSubmitted?: (flag: boolean) => void;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
    formInsert,
    activeStep,
    prevStep,
    nextStep,
    validator,
    isLoading,
    setError,
    setSubmitted
}) => {
    const { classes, cx } = useStyles();
    const { t } = useTranslation();
    const onNext = React.useCallback(() => {
        if (typeof validator !== 'undefined') {
            const validationResult = validator();
            if (validationResult === null) {
                nextStep?.();
            } else {
                setSubmitted?.(true);
                setError(validationResult);
            }
        } else {
            nextStep?.();
        }
    }, [validator, nextStep]);

    return (
        <Group
            style={{ flexDirection: 'row-reverse' }}
            position="apart"
            mt="lg"
            className={cx('', {
                [classes.formInsert]: formInsert
            })}
        >
            <Group>
                {activeStep !== 0 && prevStep ? (
                    <Button
                        variant="default"
                        onClick={() => {
                            setSubmitted?.(false);
                            prevStep();
                        }}
                        disabled={isLoading}
                    >
                        {t('back', {
                            ns: 'common'
                        })}
                    </Button>
                ) : null}
                <Button onClick={onNext} disabled={isLoading} loading={isLoading}>
                    {t('saveContinue', { ns: 'common' })}
                </Button>
            </Group>
        </Group>
    );
};
